import { CommonModule } from '@angular/common';
import { Component, Input, TemplateRef } from '@angular/core';

@Component({selector:'app-period-comparison',standalone:true,imports:[CommonModule],templateUrl:'./period-comparison.component.html',styleUrls:['./period-comparison.component.scss']})
export class PeriodComparisonComponent {
  @Input() current: TemplateRef<unknown>;
  @Input() previous: TemplateRef<unknown>;
  @Input() loading = false;
  @Input() failed = false;
  @Input() hasPrevious = false;
  @Input() currentValue: number | null | undefined;
  @Input() previousValue: number | null | undefined;
  @Input() metric = '';

  get change(): string | null {
    if (this.loading || this.failed || !this.hasPrevious || typeof this.currentValue !== 'number' || typeof this.previousValue !== 'number' || !Number.isFinite(this.currentValue) || !Number.isFinite(this.previousValue)) return null;
    const difference = this.currentValue - this.previousValue;
    if (!difference) return 'No change';
    if (!this.previousValue) return 'From 0';
    const percent = Math.abs(difference / this.previousValue * 100);
    return (difference > 0 ? '↑ ' : '↓ ') + (percent < 0.1 ? '<0.1' : new Intl.NumberFormat('en-US', {maximumFractionDigits:1}).format(percent)) + '%';
  }
}
